export enum ExamLevelEnum {

  A2 = 'A2',
  B1 = 'B1'
}
